import { Datepicker } from "vanillajs-datepicker";
import nl from "vanillajs-datepicker/locales/nl";
import en from "vanillajs-datepicker/locales/en-GB";

export class DatePicker {
    constructor(rootElement, initialDate, onChangeDate, locale = "nl", showClearButton = true) {
        this.setLocale(locale);

        // initialDate should be in the format "dd-mm-yyyy"
        this.initialDate = initialDate ? initialDate.replaceAll("/", "-") : null;
        this.onChangeDate = onChangeDate;

        this.rootElement = rootElement;

        this.setValidDates();

        this.inputElement = rootElement.querySelector("input");

        this.datePicker = new Datepicker(this.inputElement, {
            weekStart: 1, // Monday
            language: "nl",
            clearButton: showClearButton, // Show clear button
            buttonClass: "btn btn-primary",
            format: 'dd-mm-yyyy',
            datesDisabled: this.checkValidDates.bind(this) // Disable dates that are not in the validDates array
        });

        if (this.initialDate) {
            // If there is an initalDate passed in, set the datepicker to that date
             this.datePicker.setDate(this.initialDate);
             this.rootElement.classList.add("date-picker-with-date");
        }
        
        this.setEventListeners();
    }

    setLocale(locale) {
        if (locale.includes("en")) {
            en['en-GB'].clear = "All dates";
            Object.assign(Datepicker.locales, en);
        } else {
            nl.nl.clear = "Alle data";
            Object.assign(Datepicker.locales, nl);
        }
    }

    setValidDates() {
        // Get valid dates from the data-valid-dates attribute
        // If none are provided, all dates are valid
        if (this.rootElement.dataset.validDates) {
            this.validDates = JSON.parse(this.rootElement.dataset.validDates);
            if (this.initialDate && !this.validDates.includes(this.initialDate)) this.validDates = [...this.validDates, this.initialDate];
        }
    }

    setEventListeners() {
        this.inputElement.addEventListener("changeDate", () => {
            this.onChangeDate(this.datePicker.getDate());
        });

        this.inputElement.addEventListener("keydown", (e) => {
            e.preventDefault();
        });
    }

    checkValidDates(date) {
        if (!this.validDates) {
            // If no valid dates are provided, all dates are valid
            return false;
        } else {
            // Check if the date is in the validDates array
            const newDate = new Date(date).toLocaleDateString("nl").split("-").map((d) => d.padStart(2, "0")).join("-");
            return !this.validDates.includes(newDate);
        }
    }
}